/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class TableStatus.
* @enum {}
* @readonly
*/
export default class TableStatus {
    
        /**
         * value: "UPLOADED"
         * @const
         */
        "UPLOADED" = "UPLOADED";

    
        /**
         * value: "PRE PROCESSING IN PROGRESS"
         * @const
         */
        "PRE PROCESSING IN PROGRESS" = "PRE PROCESSING IN PROGRESS";

    
        /**
         * value: "PRE PROCESSING IN ERROR"
         * @const
         */
        "PRE PROCESSING IN ERROR" = "PRE PROCESSING IN ERROR";

    
        /**
         * value: "PRE PROCESSING FAILED"
         * @const
         */
        "PRE PROCESSING FAILED" = "PRE PROCESSING FAILED";

    
        /**
         * value: "PRE PROCESSING DONE"
         * @const
         */
        "PRE PROCESSING DONE" = "PRE PROCESSING DONE";

    
        /**
         * value: "ANNOTATION IN PROGRESS"
         * @const
         */
        "ANNOTATION IN PROGRESS" = "ANNOTATION IN PROGRESS";

    
        /**
         * value: "ANNOTATION IN ERROR"
         * @const
         */
        "ANNOTATION IN ERROR" = "ANNOTATION IN ERROR";

    
        /**
         * value: "ANNOTATION FAILED"
         * @const
         */
        "ANNOTATION FAILED" = "ANNOTATION FAILED";

    
        /**
         * value: "ANNOTATION DONE"
         * @const
         */
        "ANNOTATION DONE" = "ANNOTATION DONE";

    

    /**
    * Returns a <code>TableStatus</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/TableStatus} The enum <code>TableStatus</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

